module.exports = __webpack_public_path__ + "static/media/valueicon4.dc532901.svg";